import baseRequest from "../_core/baseRequest";
export default {
    getOrderList: params => baseRequest.post("/delivery/list", params),
    getOrder: params => baseRequest.get(`/delivery/${params.deliveryId}`),
    getOperationNotes: params =>
        baseRequest.get(`/delivery/order-operation-note/${params.orderId}`),
    getTransferLogs: params => baseRequest.get(`/delivery/transferlog/${params.deliveryId}`),
    cancelDelivery: params => baseRequest.put(`/delivery/${params.deliveryId}`, params),
    updateOrderOperationNote: params => baseRequest.put("/delivery/order-operation-note", params),
    approveDelivery: params => baseRequest.put(`/delivery/unapproved/${params.deliveryId}`, params),
    finishPreparation: params => baseRequest.put(`/delivery/prep/${params.deliveryId}`, params),
    getReportColumns: params =>
        baseRequest.get(`/delivery/report-columns?reportType=${params.reportType}`),
    getOrderReport: params => baseRequest.post("/delivery/report", params),
    getDeliveryOrdersReport: params => baseRequest.post("/delivery/orders-report", params),
    reOrder: params => baseRequest.post("/delivery/reorder", params),
    passOrder: params => baseRequest.post("/delivery/pass", params),
    cancelOrder: params => baseRequest.post("/delivery/cancelorder", params),
    cancelOrderByNumber: params => baseRequest.post("/delivery/cancel-order-by-number", params),
    splitOrder: params => baseRequest.post("/delivery/splitdelivery", params),
    updateStep: params => baseRequest.post("/delivery/updatestep", params),
    triggerCallback: params => baseRequest.post("/delivery/trigger-callback", params),
    getAvailableCouriersForTransfer: params =>
        baseRequest.get(`/delivery/available-couriers-for-transfer/${params.deliveryId}`),
    transferOrder: params => baseRequest.post("/delivery/transfer", params),
    trialStart: params => baseRequest.post("/delivery/trial/start", params),
    trialEnd: params => baseRequest.post("/delivery/trial/end", params),
    removePreferredCourier: params =>
        baseRequest.post("/delivery/remove-preferred-courier", params),
    updatePreferredCourier: params =>
        baseRequest.post("/delivery/update-preferred-courier", params),
    removeForceCourier: params => baseRequest.post("/delivery/remove-force-courier", params),
    updateForceCourier: params => baseRequest.post("/delivery/update-force-courier", params),
    approveAssignRequest: params => baseRequest.post("/delivery/approve-assign-request", params),
    setOrderPreparation: params =>
        baseRequest.apiRequest(
            "PATCH",
            `/order/${params.orderNumber}`,
            {prepared: params.prepared},
            params.apiKey,
            params.token,
            "json"
        ),
    rejectAssignRequest: params => baseRequest.post("/delivery/reject-assign-request", params),
    getCourierEndDayReport: params =>
        baseRequest.post("/delivery/courier-end-day-report/list", params),
    changeStatusEndDayReport: params =>
        baseRequest.post("/delivery/courier-end-day-report/change-status", params),
    bulkChangeStatusEndDayReport: params =>
        baseRequest.post("/delivery/courier-end-day-report/bulk-change-status", params)
};
